import { useFirestoreID, useFirestoreGeneralOrderBy, useFirestoreGeneralTwoOrderBy } from "../../firebase/useFirestore"
import { useState, useEffect, useMemo } from "react";
import ScrollToTop from "../../hooks/ScrollToTop";
import Location from "../../hooks/Location"
import useResearchResponseActions from "../../hooks/useResearchResponseActions";
import SelectableGrid from "../../components/common/SelectableGrid";
import ReadOnlyGuard from "../../components/common/ReadOnlyGuard";
import SuperAdmin from "../../hooks/SuperAdmin";
import orderResponsesForDisplay, { isMatrixType } from "../../helpers/questionnaire/orderResponsesForDisplay";
import ResearchResponseCards from "../../components/measurementPlan/ResearchResponseCards.jsx";
import ResearchResponsesPageHeader from "../../components/measurementPlan/ResearchResponsesPageHeader.jsx";

/**
 * Alle antwoorden op één vraag, per meetmoment, bewerkbaar voor super admins.
 */
const ResearchResponses = () => {
    // State
    const [momentID, setMoment] = useState('')
    const [questionaireId, setQuestionaireId] = useState('')

    // Hooks
    ScrollToTop()
    const superAdmin = SuperAdmin().admin
    const fieldID = Location()[3]
    const researchId = Location()[4]

    // Firestore
    const results = useFirestoreGeneralTwoOrderBy('QuestionnairesResponses', 'FieldID', fieldID ? fieldID : '', 'MomentID', momentID ? momentID : '', 'Timestamp', 'desc' )
    const momentsRaw = useFirestoreGeneralOrderBy('MeasureMoments', 'ResearchID', researchId ? researchId : '', 'Position', 'asc')
    const moments = useMemo(() => (momentsRaw || []).filter((m) => !m.Deleted), [momentsRaw])
    const fields = useFirestoreID('QuestionnaireFields', fieldID ? fieldID : '')
    const matrixRows = useFirestoreGeneralOrderBy('MatrixQuestionRows', 'Field', fieldID ? fieldID : '', 'Position', 'asc')

    const field = Array.isArray(fields) && fields[0] ? fields[0] : null
    // Het vraagtype komt van het VELD, niet van het eerste antwoord: een
    // handmatig toegevoegd antwoord staat vooraan en draagt er geen (inbox #190).
    const orderedResults = orderResponsesForDisplay(results, matrixRows, field?.Type)
    // Bij een matrixvraag hoort een handmatig toegevoegd antwoord bij geen
    // enkele stelling — dan is de plusknop een knop die stille rommel maakt.
    const canAddResponse = !isMatrixType(field?.Type)

    // Set questionnaire id in state
    useEffect(() => {
        results && results.forEach(result => {
            setQuestionaireId(result.QuestionannaireID)
        })
    },[results])

    // Set default moment in state
    useEffect(() => {
        setMoment(moments[0]?.ID)
    },[moments])

    const { inputHandler, deleteResult, addResult } = useResearchResponseActions({
        fieldID,
        momentID,
        researchId,
        questionaireId,
        fieldType: field?.Type,
        results,
    })

  return (
    <div className="main">
        <div className="main-container">
            <ResearchResponsesPageHeader field={field} />
            <SelectableGrid
                items={moments || []}
                getId={(item) => item.ID}
                getLabel={(item) => item.Title}
                selectedId={momentID}
                onClick={setMoment}
            />
            <ReadOnlyGuard edit="measurement.edit">
                {(canEdit) => (
                    // Toevoegen en wijzigen blijft bij Deccos; verwijderen (naar de
                    // prullenbak) mag de organisatie zelf, voor haar testinvullingen.
                    <ResearchResponseCards
                        results={orderedResults}
                        loaded={Array.isArray(results)}
                        canCrud={superAdmin && canEdit}
                        canDelete={canEdit}
                        canAdd={canAddResponse}
                        onInput={inputHandler}
                        onDelete={deleteResult}
                        onAdd={addResult}
                    />
                )}
            </ReadOnlyGuard>
        </div>
    </div>
  )
}

export default ResearchResponses
